import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteConfigContext = createContext(null);

const FALLBACK = {
  name: "Dilip Hiremath",
  role: "Senior Software Engineer",
  years_experience: 8,
  tagline: "",
  bio: "",
  location: "",
  email: "dilip.s.hiremath@gmail.com",
  profile_image_url: "",
  hero_kicker: "Dilip",
  hero_headline: "Engineering with intent.",
  hero_sub: "",
  hero_cta_primary_label: "View projects",
  hero_cta_primary_href: "/projects",
  hero_cta_secondary_label: "Read the blog",
  hero_cta_secondary_href: "/blog",
  footer_note: "",
  social_links: [],
  theme: { accent: "#002FA7", accent_dark: "#FF3333" },
};

export function SiteConfigProvider({ children }) {
  const [config, setConfig] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site-config");
      setConfig(data);
      applyThemeVars(data);
    } catch {
      // keep fallback
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteConfigContext.Provider value={{ config, loading, refresh, setConfig }}>
      {children}
    </SiteConfigContext.Provider>
  );
}

function applyThemeVars(cfg) {
  if (!cfg?.theme) return;
  const isDark = document.documentElement.classList.contains("dark");
  document.documentElement.style.setProperty(
    "--brand-accent",
    isDark ? cfg.theme.accent_dark : cfg.theme.accent,
  );
}

export const useSiteConfig = () => useContext(SiteConfigContext);
export { applyThemeVars };
